import React from "react"

import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"

const ProductAccordionItem = ({ title, children }) => (
  <AccordionItem>
    <AccordionItemHeading>
      <AccordionItemButton>{title}</AccordionItemButton>
    </AccordionItemHeading>
    <AccordionItemPanel>{children}</AccordionItemPanel>
  </AccordionItem>
)

export default ProductAccordionItem
